<template>
  <van-pull-refresh
    v-if="dataArr.length > 0"
    v-model="refreshing"
    success-text="刷新成功"
    @refresh="onRefresh"
  >
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      :offset="0"
      @load="onLoad"
    >
      <div class="article-list">
        <div v-for="item in listArr" :key="item.TenantId" class="top_text">
          <div class="tx">
            <div class="face">
              <a href="javascript:;">
                <van-image
                  height="44"
                  lazy-load
                  round
                  :src="$getAvatar(item.Avatar)"
                  width="44"
                />
              </a>
            </div>
          </div>
          <div class="left_txt">
            <div class="tools">
              <article-tools :data="item" @delDone="delDone(index)" />
            </div>
            <p class="h3">{{ item.NickName }}</p>
            <h4>{{ item.Title }}</h4>
            <!-- <p v-html="item.Text"></p> -->
            <ReadArticle
              v-if="item.Text != '' && item.Text"
              :content="item.Text ? item.Text.replace(/\n/g, '<br/>') : ''"
            />
            <ul
              v-if="item.Image.length > 0"
              class="img-list flex flex-wrap"
              :class="'list-' + item.Image.length"
            >
              <li
                v-for="(item2, index2) in item.Image"
                :key="index2"
                class="img_list"
              >
                <van-image
                  v-if="item2"
                  class="li_img"
                  fit="cover"
                  lazy-load
                  :src="
                    item2 != ''
                      ? api.FileHost + item2
                      : '@/assets/images/bj.png'
                  "
                  @click.stop="showImg(item.Image, index2)"
                />
              </li>
            </ul>
            <ul
              v-if="item.Video.length > 0"
              class="video-list-v2 flex flex-wrap"
              :class="'list-' + item.Video.length"
              @click.stop=""
            >
              <li
                v-for="(item2, index2) in item.Video"
                :key="index2"
                ref="videobox"
              >
                <video
                  v-if="item2"
                  class="video"
                  controls
                  crossOrigin="Anonymous"
                  muted
                  playsinline
                  :poster="item.VideoCover[index2] || poster"
                  preload="auto"
                  :src="api.FileHost + item2"
                  webkit-playsinline="true"
                  x-webkit-airplay="true"
                  x5-video-player-type="h5"
                ></video>
              </li>
            </ul>
            <div class="li-fd flex">
              <div class="flex-1 date" style="color: #777; font-size: 15px">
                {{ getTimer(item.LastUpdatedDate) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
  <p
    v-else
    style="text-align: center; font-size: 12px; color: #888; margin-top: 20px"
  >
    暂无经典案例~~
  </p>
</template>
<script>
  import { onActivated, onMounted, ref, watch } from 'vue'
  import ArticleTools from '../ArticleTools'
  import ReadArticle from '@/components/ReadArticle'
  import store from '@/store'
  import api from '@/api'
  import { ImagePreview, Toast } from 'vant'

  //import CopyRight from '@/components/Copyright'
  export default {
    components: {
      ReadArticle,
      ArticleTools,
    },
    props: {
      prodid: {
        type: String,
        default: '',
      },
    },
    setup(props) {
      const listArr = ref([])
      const tenant = ref(null)
      const loading = ref(false)
      const finished = ref(false)
      const refreshing = ref(false)
      const finishedText = ref('')
      const pageSize = ref(10)
      const dataArr = ref([])
      const poster = ref(null)
      const pageIndex = ref(1)
      const Total = ref(null)
      onMounted(() => {
        dataArr.value = []
        init()
      })
      watch(
        () => props.prodid,
        () => {
          dataArr.value = []
          init()
        }
      )
      const init = async () => {
        //var u = navigator.userAgent
        //var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
        //if (!isiOS) {
        const logo = (await store.getters['user/getTenant']).LogoLarge
        tenant.value = await store.getters['user/getTenant']
        poster.value = api.FileHost + logo
        let newDataArr = []
        //GetCaseIds(tenant.value)
        await store
          .dispatch('service/GetCaseIds', {
            productId: props.prodid,
            tenantId: tenant.value.TenantId,
          })
          .then((res) => {
            if (res.Code === 0) {
              //console.log('ID列表 :>> ', res.Data.CaseIds.length)
              if (res.Data.CaseIds.length > 0) {
                dataArr.value = res.Data.CaseIds
                newDataArr = res.Data.CaseIds
                //console.log('dataArr.value :>> ', dataArr.value)
              }
            }
          })
        //console.log('newDataArr------------ :>> ', newDataArr)
        if (dataArr.value.length > 0) {
          SelectByIdList()
        }

        //}
      }
      const showImg = (list, index) => {
        const arr = []
        list.forEach((item) => {
          arr.push(api.FileHost + item)
        })
        ImagePreview({
          images: arr,
          startPosition: index,
          showIndex: false,
          showIndicators: true,
          overlayStyle: {
            background: '#000',
          },
          //closeable: true,
        })
      }

      const setCover = () => {
        const list = listArr.value
        //console.log('list', list)
        for (let index = 0; index < list.length; index++) {
          const item = list[index]
          if (item.Video.length > 0) {
            //console.log('item', item)
            createCover(item)
          }
        }
      }

      const createCover = async (item) => {
        //console.log('item Cover :>> ', item)
        if (item.Video.length == item.VideoCover.length) return
        const vidoe = item.Video
        if (item.Video.length <= 0) return
        for (let index = 0; index < vidoe.length; index++) {
          const item2 = vidoe[index]
          //console.log('item2', item2)
          const url = api.FileHost + item2 //视频地址
          const base64 = await getVideoBase64(url)
          item.VideoCover.push(base64)
        }
      }

      const getVideoBase64 = (url) => {
        return new Promise(function (resolve) {
          let dataURL = ''
          const video = document.createElement('video')
          video.setAttribute('crossOrigin', 'anonymous')
          video.setAttribute('src', url)
          video.setAttribute('preload', 'auto')
          //video.setAttribute('autoplay', true)
          video.addEventListener('loadeddata', function () {
            const canvas = document.createElement('canvas')
            // console.log('video.clientWidth', video.videoWidth) // 视频宽
            // console.log('video.clientHeight', video.videoHeight) // 视频高
            const width = video.videoWidth || 400 // canvas的尺寸和图片一样
            const height = video.videoHeight || 240 // 设置默认宽高为  400  240
            canvas.width = width
            canvas.height = height
            canvas.getContext('2d').drawImage(video, 0, 0, width, height) // 绘制canvas
            dataURL = canvas.toDataURL('image/jpeg') // 转换为base64
            resolve(dataURL)
          })
        })
      }
      //生成图片
      const delDone = (index) => {
        listArr.value.splice(index, 1)
      }
      //获取产品引用的ID列表
      // const GetCaseIds = (tenant) => {
      //   store
      //     .dispatch('service/GetCaseIds', {
      //       productId: props.prodid,
      //       tenantId: tenant.TenantId,
      //     })
      //     .then((res) => {
      //       if (res.Code === 0) {
      //         console.log('ID列表 :>> ', res.Data.CaseIds.length)
      //         if (res.Data.CaseIds.length > 0) {
      //           dataArr.value = res.Data.CaseIds
      //           console.log('dataArr.value :>> ', dataArr.value)
      //         }
      //       }
      //     })
      // }
      //按ID列表获取帖子列表
      const SelectByIdList = () => {
        store
          .dispatch('service/SelectByIdList', {
            idList: dataArr.value,
            asc: true,
            pageIndex: pageIndex.value,
            pageSize: pageSize.value,
            tenantId: tenant.value.TenantId,
          })
          .then((res) => {
            if (res.Code === 0) {
              if (refreshing.value) {
                // 下拉刷新
                listArr.value = []
                refreshing.value = false
              }
              if (pageIndex.value == 1) {
                loading.value = false
                listArr.value = res.Data.CurrentPage
                listArr.value.map((item) => {
                  item.VideoCover = []
                })
                Total.value = res.Data.Total
              } else {
                loading.value = false
                listArr.value = listArr.value.concat(res.Data.CurrentPage)
                listArr.value.map((item) => {
                  item.VideoCover = []
                })
                Total.value = res.Data.Total
              }
              if (res.Data.CurrentPage.length == 0) {
                finished.value = true
                finishedText.value = '暂无更多数据'
              } else if (res.Data.CurrentPage.length < pageSize.value) {
                finished.value = true
                finishedText.value = '没有更多啦'
              }
            }
          })
      }
      watch(
        () => listArr.value.length,
        () => {
          setCover()
        }
      )
      const onLoad = () => {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        pageIndex.value++
        SelectByIdList()
      }
      const getTimer = (stringTime) => {
        var minute = 1000 * 60
        var hour = minute * 60
        var day = hour * 24
        var week = day * 7
        var month = day * 30
        var time1 = new Date().getTime() //当前的时间戳
        var time2 = Date.parse(new Date(stringTime)) //指定时间的时间戳
        var time = time1 - time2

        var result = null
        if (time < 0) {
          result = ''
        } else if (time / month >= 1) {
          result = parseInt(time / month) + '月前'
        } else if (time / week >= 1) {
          result = parseInt(time / week) + '周前'
        } else if (time / day >= 1) {
          result = parseInt(time / day) + '天前'
        } else if (time / hour >= 1) {
          result = parseInt(time / hour) + '小时前'
        } else if (time / minute >= 1) {
          result = parseInt(time / minute) + '分钟前'
        } else {
          result = '刚刚'
        }
        return result
      }
      //点赞接口
      const zanHandle = (item, type = 3) => {
        console.log('item :>> ', item)
        const params = {
          ArticleId: item.Id,
          OperationType: type,
        }
        let url = 'case/ArticleOperationIncrease'
        //let url = 'service/SelectByIdList'
        if (item.Article && item.Article.IsPraise) {
          url = 'case/ArticleOperationIncrease'
        }
        store
          .dispatch(url, params)
          .then((data) => {
            if (data.Code === 0) {
              Toast('点赞成功')
            }
          })
          .catch((e) => {
            //console.log(e)
            Toast.fail('点赞失败')
          })
      }
      //获取点赞列表信息
      const setArticleInfo = (li, list) => {
        //console.log('list--------------------- :>> ', list)
        store
          .dispatch('case/GetBatchArticleStatistics', list)
          .then((data) => {
            const d = data.Data
            //console.log('d :>> ', d)
            li.forEach((item) => {
              d.forEach((item2) => {
                if (item.Id === item2.ArticleId) {
                  item.Article = item2
                }
              })
            })
          })
          .catch((e) => {})
      }
      //下拉刷新
      const onRefresh = () => {
        finished.value = false
        loading.value = true
        refreshing.value = true
        pageIndex.value = 1
        SelectByIdList()
      }

      return {
        listArr,
        loading,
        finished,
        onRefresh,
        refreshing,
        pageSize,
        finishedText,
        tenant,
        onLoad,
        showImg,
        dataArr,
        getTimer,
        zanHandle,
        setArticleInfo,
        delDone,
        getVideoBase64,
        createCover,
        setCover,
        poster,
        init,
        pageIndex,
        Total,
      }
    },
    data() {
      return {
        api,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .article-list {
    padding: 0 20px;
  }
  .html {
    word-break: break-all;
  }
  .van-tabs__nav--line {
    border: 1px solid #eee !important;
  }
  .flex {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .top_text {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px 0;
    background-color: #fff;
    border-bottom: 1px solid #e8e8e9;
    .tx {
      width: 20%;
    }
    .left_txt {
      width: 90%;
      position: relative;
      .tools {
        position: absolute;
        top: 10px;
        right: 15px;
      }
      ul {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-top: 15px;
        .img_list {
          // width: 80px;
          // height: 80px;
          // margin: 0 10px 10px 0;
          .li_img {
            width: 80px;
            height: 80px;
            margin-right: 6px;
          }
        }
      }
      .h3 {
        font-size: 15px;
        font-family: 'Source Han Sans CN';
        margin-bottom: 10px;
        color: #666;
      }
      h4 {
        font-weight: normal;
        color: #000000;
        font-size: 16px;
      }
      h5 {
        font-size: 16px;
        font-family: 'Source Han Sans CN';
        color: #000000;
        margin-bottom: 7px;
      }
      p {
        font-size: 14px;
        font-family: 'Source Han Sans CN';
        font-weight: 500;
        color: #888;
      }
      .bottom_img {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        div {
          margin-right: 8px;
          img {
            width: 78px;
            height: 78px;
          }
        }
      }
    }
  }
  .line_box {
    border-bottom: 1px solid #ccc;
    position: absolute;
    width: 100%;
    height: 1px;
    top: 246px;
    left: 0;
    z-index: 999;
  }
</style>
